export default __webpack_public_path__ + "static/rose-7d7d5be5c9ed54c23cc1910b8ff5250d.webp";